/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please access this page through the Minecraft mod.`)
};

const zh_hans1_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请通过 Minecraft 模组访问该页面。`)
};

const zh_hant1_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請透過 Minecraft 模組存取此頁面。`)
};

const fr_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez accéder à cette page via le mod Minecraft.`)
};

const de_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte rufe diese Seite über den Minecraft-Mod auf.`)
};

const ja_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft の Mod からこのページにアクセスしてください。`)
};

const ko_error_page_invalid_request_desc_line2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 모드를 통해 이 페이지에 접근해 주세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error_page_invalid_request_desc_line2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error_page_invalid_request_desc_line2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error_page_invalid_request_desc_line2", locale)
	if (locale === "en") return en_error_page_invalid_request_desc_line2(inputs)
	if (locale === "zh-Hans") return zh_hans1_error_page_invalid_request_desc_line2(inputs)
	if (locale === "zh-Hant") return zh_hant1_error_page_invalid_request_desc_line2(inputs)
	if (locale === "fr") return fr_error_page_invalid_request_desc_line2(inputs)
	if (locale === "de") return de_error_page_invalid_request_desc_line2(inputs)
	if (locale === "ja") return ja_error_page_invalid_request_desc_line2(inputs)
	return ko_error_page_invalid_request_desc_line2(inputs)
};